// File Name: src/lib/site.js

import axios from "axios";

/* BACKEND API */
export const API = "http://localhost:8000/api";

export const api = axios.create({
  baseURL: API,
});

/* COMPANY */
export const COMPANY = {
  name: "CodeFix Solutions",
  tagline: "Building Future-Ready Technology",
  email: "codefixsolutions01@gmail.com",
  phone: "+91 7075392825",
  whatsapp: "+91 7075392825",

  social: {
    linkedin: "https://www.linkedin.com",
    instagram: "https://www.instagram.com",
    facebook: "https://www.facebook.com",
  },
};

/* SERVICES */
export const SERVICES = [
  {
    slug: "it-services",
    title: "IT Services",
    short: "Modern engineering for digital products and platforms.",
    icon: "Cpu",
    items: [
      "Web Development",
      "Software Development",
      "Cloud Solutions",
      "Cybersecurity",
      "Application Maintenance",
    ],
  },

  {
    slug: "staffing-solutions",
    title: "Staffing Solutions",
    short: "Right talent, fast — for permanent, contract and remote roles.",
    icon: "Users",
    items: [
      "IT Recruitment",
      "Remote Staffing",
      "Contract Hiring",
      "Talent Acquisition",
    ],
  },

  {
    slug: "business-consulting",
    title: "Business Consulting",
    short: "Strategy and execution that compound across quarters.",
    icon: "LineChart",
    items: [
      "Digital Transformation",
      "Process Optimization",
      "Technology Consulting",
      "Business Strategy",
    ],
  },

  {
    slug: "human-resources",
    title: "Human Resources",
    short: "People operations infrastructure for growing teams.",
    icon: "HeartHandshake",
    items: [
      "HR Management",
      "Employee Solutions",
      "Payroll Support",
      "Organizational Development",
    ],
  },
];

/* STATS */
export const STATS = [
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 100, suffix: "+", label: "Clients Served" },
  { value: 50, suffix: "+", label: "Projects Delivered" },
  { value: 24, suffix: "/7", label: "Support" },
];

/* TEAM */
export const TEAM = [
  {
    name: "James Anderson",
    role: "President & CEO",
    img: "https://images.unsplash.com/photo-1758518731468-98e90ffd7430?w=600&h=750&fit=crop",
  },

  {
    name: "Ibtehaj Syed",
    role: "Director & HR Head",
    img: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?w=600&h=750&fit=crop",
  },

  {
    name: "Daniel Foster",
    role: "Chief Marketing Officer",
    img: "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?w=600&h=750&fit=crop",
  },

  {
    name: "Abraham J. Mitchel",
    role: "Chief Financial Officer",
    img: "https://images.unsplash.com/photo-1739298061757-7a3339cee982?w=600&h=750&fit=crop",
  },
];

/* PARTNERS */
export const PARTNERS = [
  { name: "BlueBriss Systems" },
  { name: "Crescent IT Solutions" },
  
];

/* FAQ */
export const FAQS = [
  {
    q: "What services does CodeFix Solutions provide?",
    a: "We deliver IT Services, Staffing Solutions, Business Consulting, and Human Resources support for businesses ranging from early-stage to enterprise.",
  },

  {
    q: "How can we contact your team?",
    a: "Use the contact form, email contact@codefixsolutions.com, or click the WhatsApp button — we typically respond within a few hours during business days.",
  },

  {
    q: "How does the hiring process work?",
    a: "Apply online with a resume. Our team reviews within 5 business days, followed by 2-3 interview rounds and an offer.",
  },

  {
    q: "Do you provide remote staffing solutions?",
    a: "Yes — we have a global remote talent network across engineering, design, data and operations.",
  },

  {
    q: "What industries do you specialize in?",
    a: "Fintech, logistics, healthcare, manufacturing and SaaS — though our core stack is industry-agnostic.",
  },

  {
    q: "Do you offer 24/7 support?",
    a: "Yes, our managed-services tiers include round-the-clock incident response and monitoring.",
  },
];

/* WHY CHOOSE */
export const WHY_CHOOSE = [
  {
    title: "10+ Years of Experience",
    desc: "Proven delivery across hundreds of engagements globally.",
  },

  {
    title: "Professional Team",
    desc: "Senior engineers, designers, recruiters and consultants.",
  },

  {
    title: "Modern Technology",
    desc: "Cloud-native, AI-powered, security-first by design.",
  },

  {
    title: "Trusted Relationships",
    desc: "Multi-year partnerships with returning customers.",
  },

  {
    title: "24/7 Support",
    desc: "Always-on operations, monitoring and incident response.",
  },

  {
    title: "Scalable Solutions",
    desc: "Architecture that grows with your business needs.",
  },
];